// Prepínač CZ ↔ SK v topbare — slovenské dvojča locale/cs/countrySwitch.js.
export default {
  nav: 'E-shop v inej krajine',
  names: {
    CZ: 'Česko',
    SK: 'Slovensko',
  },
};
